//LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";

const AboutUsMain: React.FC = () => {

    const { t } = useTranslation();

    return(
        <div className="row align-items-center justify-content-around">
            <div className="col-12 col-lg-6 mb-4 order-lg-1">
                <p className="mb-0" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para1') as string }} />
            </div>
            <div className="col-12 col-lg-6 col-xl-5 mb-4 order-lg-2">
                <img src="assets/images/altrePag/fucecchio.jpg" className="img-fluid" alt={`${t('aboutUsPage.imgAlt1')}`} />
            </div>
            <div className="col-12 col-lg-6 mb-4 order-lg-4">
                <p className="mb-0" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para2') as string }} />
            </div>
            <div className="col-12 col-lg-6 col-xl-5 order-lg-3">
                <img src="assets/images/altrePag/abitare.jpg" className="img-fluid" alt={`${t('aboutUsPage.imgAlt2')}`} />
            </div>
        </div>
    )
};
export default AboutUsMain;